import { useEffect } from 'react';
import { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
    display: inline-block;
    position: relative;
    z-index: 1;
`;

const InputElement = styled.input`
    border: 0;
    border-width: 0 0 1px 0!important;
    border-radius: 0px!important;
    padding: 12px 0!important;
    margin: 8px 0!important;
    outline: none;
    background-color: transparent;
    z-index: 1;

    &[type="checkbox"] {
        width: 20px !important;
    }

    border-bottom: 1px solid #ccc;
    ::placeholder {
        color: #999;
    }

    &.crayon_editable {
        background-image: url('/img/crayon.png');
        background-repeat: no-repeat;
        background-position: right 10px center;
        background-size: 15px;
    }

    &.number_input {
        padding: 12px 12px!important;
        /* background-image: url('/img/chevron_dropdown.png');
        background-repeat: no-repeat;
        background-position: right 15px center;
        background-size: 10px; */
    }
`;

const Placeholder = styled.span`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: ${props => props.paddingLeft ? '12px' : '2px'};
    color: #999;
    font-size: inherit;
    pointer-events: none;
    z-index: -1;

    .star {
        color: red;
    }
`;

const Input = ({ ...props }) => {

    const [value, setValue] = useState(props.defaultValue || props.value);
    const [showingPassword, setShowingPassword] = useState(false);

    useEffect(() => {
        setValue(props.defaultValue || props.value);
    }, [props.defaultValue, props.value]);

    if (!props.readOnly && props.type !== "number" && props.type !== "password"){
        props.className = 'crayon_editable';
    }

    if (props.type === "number"){
        props.className = 'number_input';
    }

    const fakePlaceholder = props.placeholder;

    function onChange(e){
        setValue(e.target.value);
        if (props.onChange) props.onChange(e);
    }

    // if(props.name === "adresse"){
    //     console.log("adresse input props : ");
    //     console.log(props);
    //     console.log("adresse input value : ");
    //     console.log(value);
    // }

    return (
        <Container style={props.style}>
            <InputElement {...props} placeholder="" type={showingPassword ? "text" : props.type} style={props.style || {width:"100%"}} onChange={onChange}/>
            {!value && 
                <Placeholder paddingLeft={props.type === "number"}>
                    {fakePlaceholder}{fakePlaceholder && props.required && <span className='star'>*</span>}
                </Placeholder>
            }
            {props.type === "password" && 
                <img src={showingPassword ? "/img/eye.png" : "/img/eye_slash.png"} style={{position:"absolute", width:"20px",right:"7px",top:"0",cursor:"pointer"}} onClick={() => setShowingPassword(!showingPassword)} alt=""/>
            }
        </Container>
    );
};

export default Input;
